import { render, staticRenderFns } from "./VerifyEmailModal.vue?vue&type=template&id=fe5850ca&"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports